// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"d3103b9d","400":"c0b7a5d7"}[chunkId] + ".chunk.css";
};